import { Injectable, inject } from '@angular/core';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

function getAuthConfig(): AuthConfig {
  return {
    issuer: environment.keycloakUrl,
    clientId: environment.keycloakClientId,
    redirectUri: typeof window !== 'undefined' ? window.location.origin + '/login' : '/login',
    responseType: 'code',
    scope: 'openid profile',
    showDebugInformation: !environment.production,
  };
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private oauthService = inject(OAuthService);

  constructor() {
    this.oauthService.configure(getAuthConfig());
  }

  async init(): Promise<void> {
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }

  login(): void {
    this.oauthService.initCodeFlow();
  }

  register(): void {
    this.oauthService.initCodeFlow(undefined, { kc_action: 'register' });
  }

  logout(): void {
    this.oauthService.logOut();
  }

  getToken(): string | null {
    return this.oauthService.getIdToken() || null;
  }

  isAuthenticated(): boolean {
    return this.oauthService.hasValidIdToken();
  }
}
